import { useIntl } from '@/intl'
import { AgeProfilesNew } from '@/scopes/prices/components/RoomSelector/AgeProfilesNew'
import { RoomGroupNew } from '@/scopes/prices/components/RoomSelector/RoomGroupNew'
import {
  getRoomsResponseSelector,
  getRoomsSelector,
  selectedPriceIdSelector,
} from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Button, SpaceBetween, tk, Typography, UnavailableContentDialog } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'

const RoomSelectorHeading = styled(Typography)`
  ${Typography.modVariant('heading-md')}
  @media ${tk('mq_desktop_sm')} {
    ${Typography.modVariant('heading-lg')}
  }
`

export function RoomSelectorNew() {
  const intl = useIntl()
  const selectedPriceId = usePricesSelector(selectedPriceIdSelector)
  const { roomGroups } = usePricesSelector(getRoomsResponseSelector)
  const { error: isError, loading: isFetching } = usePricesSelector(getRoomsSelector)

  if (isError) {
    return (
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'prices_room_selector_error_title' })}
        message={intl.formatMessage({ id: 'prices_room_selector_error_message' })}
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </UnavailableContentDialog>
    )
  }

  if (isEmpty(roomGroups) || !selectedPriceId || isFetching)
    return null

  return (
    <SpaceBetween id="RoomSelector" direction="y" spacing={tk('spacing_lg')}>
      <RoomSelectorHeading>{intl.formatMessage({ id: 'prices_room_selector-title' })}</RoomSelectorHeading>
      <AgeProfilesNew />
      {roomGroups.map(roomGroup => (
        <RoomGroupNew key={roomGroup.roomNumber} {...roomGroup} />
      ))}
    </SpaceBetween>
  )
}
